@if (visible()) {
  <div class="global-busy-indicator">
    <div class="indicator">
      <div class="progress">
        <div class="progress-bar progress-bar-striped active" role="progressbar" style="width: 100%; height: 10px"></div>
      </div>
    </div>
  </div>
}
